<template>
	<div class="dashboard-container">
		<!-- 统计卡片 -->
		<el-row :gutter="20" class="stats-row">
			<el-col :span="5">
				<el-card class="stat-card">
					<div class="stat-content">
						<div class="stat-icon" style="background: #409EFF;">
							<i class="el-icon-monitor"></i>
						</div>
						<div class="stat-info">
							<div class="stat-value">{{ dashboardData.deviceTotal }}</div>
							<div class="stat-label">设备总数</div>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="5">
				<el-card class="stat-card">
					<div class="stat-content">
						<div class="stat-icon" style="background: #F56C6C;">
							<i class="el-icon-close-notification"></i>
						</div>
						<div class="stat-info">
							<div class="stat-value">{{ dashboardData.offlineCount }}</div>
							<div class="stat-label">离线设备数</div>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="5">
				<el-card class="stat-card">
					<div class="stat-content">
						<div class="stat-icon" style="background: #67C23A;">
							<i class="el-icon-refresh"></i>
						</div>
						<div class="stat-info">
							<div class="stat-value">{{ dashboardData.chargingCount }}</div>
							<div class="stat-label">充电次数（{{ getTimeRangeLabel() }}）</div>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="5">
				<el-card class="stat-card">
					<div class="stat-content">
						<div class="stat-icon" style="background: #E6A23C;">
							<i class="el-icon-coin"></i>
						</div>
						<div class="stat-info">
							<div class="stat-value">¥{{ dashboardData.chargingAmount }}</div>
							<div class="stat-label">充电金额（{{ getTimeRangeLabel() }}）</div>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="4">
				<el-card class="stat-card">
					<div class="stat-content">
						<div class="stat-info">
							<div class="stat-value">
								<el-radio-group v-model="timeRange" @change="changeTimeRange" size="small">
									<el-radio-button label="day">当日</el-radio-button>
									<el-radio-button label="month">当月</el-radio-button>
									<el-radio-button label="lastMonth">上月</el-radio-button>
								</el-radio-group>
							</div>
							<div class="stat-label">统计时间范围</div>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>

		<!-- 时间范围切换 - 重新设计 -->
		<el-row v-if="false" :gutter="20" style="margin-top: 20px;">
			<el-col :span="24">
				<el-card class="time-range-card">
					<div class="time-range-header">
						<i class="el-icon-date"></i>
						<span class="time-range-title">统计时间范围</span>
					</div>
					<div class="time-range-buttons">
						<div 
							class="time-range-btn" 
							:class="{ active: timeRange === 'day' }"
							@click="changeTimeRange('day')">
							<div class="btn-icon">
								<i class="el-icon-sunny"></i>
							</div>
							<div class="btn-content">
								<div class="btn-label">当日</div>
								<div class="btn-desc">Today</div>
							</div>
						</div>
						<div 
							class="time-range-btn" 
							:class="{ active: timeRange === 'month' }"
							@click="changeTimeRange('month')">
							<div class="btn-icon">
								<i class="el-icon-calendar"></i>
							</div>
							<div class="btn-content">
								<div class="btn-label">当月</div>
								<div class="btn-desc">This Month</div>
							</div>
						</div>
						<div 
							class="time-range-btn" 
							:class="{ active: timeRange === 'lastMonth' }"
							@click="changeTimeRange('lastMonth')">
							<div class="btn-icon">
								<i class="el-icon-time"></i>
							</div>
							<div class="btn-content">
								<div class="btn-label">上月</div>
								<div class="btn-desc">Last Month</div>
							</div>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>

		<!-- 图表区域 -->
		<el-row :gutter="20" style="margin-top: 20px;">
			<el-col :span="24">
				<el-card>
					<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
						<h3 style="margin: 0;">充电数据趋势</h3>
						<el-radio-group v-model="chartRange" @change="handleChartRangeChange" size="small">
							<el-radio-button label="7">近7天</el-radio-button>
							<el-radio-button label="30">近30天</el-radio-button>
						</el-radio-group>
					</div>
					<div class="chart-container" id="chargingChart"></div>
				</el-card>
			</el-col>
		</el-row>

		<!-- 收益排行榜 -->
		<el-row :gutter="20" style="margin-top: 20px;">
			<el-col :span="24">
				<el-card>
					<h3 style="margin: 0 0 20px 0;">收益排行榜</h3>
					<el-table
						:data="rankingList"
						border
						stripe
						style="width: 100%">
						<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
						<el-table-column prop="deviceName" label="设备名称" sortable align="center">
							<template slot-scope="scope">
								<span :title="scope.row.deviceName" style="cursor: pointer; color:#409EFF" @click="handleDeviceNameClick(scope.row.deviceId)">{{ scope.row.deviceName }}</span>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="deviceId" label="设备ID" align="center"></el-table-column> -->
						<el-table-column prop="inactivePorts" label="近3日未使用端口" align="center">
							<template slot-scope="scope">
								<span>{{ scope.row.inactivePorts.length ? scope.row.inactivePorts.join('、') : '-' }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="dayCount" label="今日充电次数" align="center"></el-table-column>
						<el-table-column prop="dayAmount" label="今日收益（元）" sortable align="center" >
							<template slot-scope="scope">
								<span style="color: #E6A23C; font-weight: bold;">¥{{ scope.row.dayAmount }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="chargingCount" label="当月充电次数" align="center"></el-table-column>
						<el-table-column prop="amount" label="当月收益（元）" sortable align="center">
							<template slot-scope="scope">
								<span style="color: #E6A23C; font-weight: bold;">¥{{ scope.row.amount }}</span>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import { getDevices } from '../apis/devices.js'
import { getCountAndAmount, getDailyData, getDeviceRanking } from '../apis/statistics.js'

export default {
	name: "Index",
	data() {
		return {
			timeRange: 'day', // 'day'、'month' 或 'lastMonth'
			chartRange: '7', // '7' 或 '30'
			dashboardData: {
				deviceTotal: 0,
				offlineCount: 0,
				chargingCount: 0,
				chargingAmount: '0.00'
			},
			rankingList: [],
			chart: null,
			loading: false,
			timer: null
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.initChart()
			this.loadDashboardData()
		})
		window.addEventListener('resize', this.handleResize)

		this.timer = setInterval(() => {
			this.initChart()
			this.loadDashboardData()
		// }, 1000 * 10)
		}, 1000 * 60 * 5)
	},
	beforeDestroy() {
		clearInterval(this.timer)
		window.removeEventListener('resize', this.handleResize)
		if (this.chart) {
			this.chart.dispose()
		}
	},
	methods: {
		handleDeviceNameClick(deviceName){
			this.$router.push({name: 'Device', query: {deviceName: deviceName}})
		},
		// 加载设备总数和离线数
		loadDeviceStats() {
			getDevices({page: 1}).then(res => res.data).then(res => {
				if (res.code == 200) {
					let res1 = res.data
					if (res1.err_code == 200 && res1.data && res1.data.total_data) {
						const totalData = res1.data.total_data
						this.dashboardData.deviceTotal = totalData.total || 0
						// 根据在线率计算离线数
						const onlineRate = totalData.online_rate || 0
						const onlineCount = Math.round(this.dashboardData.deviceTotal * onlineRate / 100)
						this.dashboardData.offlineCount = this.dashboardData.deviceTotal - onlineCount
					}
				}
			}).catch(error => {
				console.error('获取设备统计失败:', error)
			})
		},
		// 加载充电次数和金额
		loadChargingStats() {
			let type = 'today'
			if (this.timeRange === 'month') {
				type = 'month'
			} else if (this.timeRange === 'lastMonth') {
				type = 'lastMonth'
			}
			getCountAndAmount({ type: type }).then(res => res.data).then(res => {
				if (res.code == 200 && res.data) {
					this.dashboardData.chargingCount = res.data.count || 0
					// 金额可能是分，需要转换为元
					let amount = res.data.totalAmount || 0
					// if (amount > 1000) {
						// 如果金额很大，可能是分，转换为元
						amount = amount / 100
					// }
					this.dashboardData.chargingAmount = this.formatAmount(amount)
				} else {
					this.dashboardData.chargingCount = 0
					this.dashboardData.chargingAmount = '0.00'
				}
			}).catch(error => {
				console.error('获取充电统计失败:', error)
				this.dashboardData.chargingCount = 0
				this.dashboardData.chargingAmount = '0.00'
			})
		},
		// 加载数据看板
		loadDashboardData() {
			this.loadDeviceStats()
			this.loadChargingStats()
			this.loadRankingData()
			this.updateChart()
		},
		// 加载收益排行榜
		loadRankingData() {
			getDeviceRanking().then(res => res.data).then(res => {
				if (res.code == 200 && res.data) {
					// 处理数据，确保格式正确
					this.rankingList = (res.data || []).map(item => {
						let amount = item.amount || 0
						amount = amount / 100
						let dayAmount = item.dayAmount || 0
						dayAmount = dayAmount / 100
						return {
							deviceName: item.deviceName || item.location || '未知设备',
							deviceId: item.deviceId || item.productId || '',
							chargingCount: item.count || 0,
							dayCount: item.dayCount || 0,
							inactivePorts: item.inactivePorts || [],
							amount: this.formatAmount(amount),
							dayAmount: this.formatAmount(dayAmount),
						}
					})
				} else {
					this.rankingList = []
				}
			}).catch(error => {
				console.error('获取收益排行榜失败:', error)
				this.rankingList = []
			})
		},
		// 格式化金额
		formatAmount(amount) {
			if (!amount && amount !== 0) return 0
			const num = parseInt(amount)
			if (isNaN(num)) return 0
			// 保留两位小数，并添加千分位
			return parseInt(num)
			// if (!amount && amount !== 0) return '0.00'
			// const num = parseFloat(amount)
			// if (isNaN(num)) return '0.00'
			// // 保留两位小数，并添加千分位
			// return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
		},
		// 获取时间范围标签
		getTimeRangeLabel() {
			if (this.timeRange === 'day') {
				return '当日'
			} else if (this.timeRange === 'month') {
				return '当月'
			} else if (this.timeRange === 'lastMonth') {
				return '上月'
			}
			return '当日'
		},
		// 切换时间范围
		changeTimeRange(range) {
			this.timeRange = range
			this.loadChargingStats()
		},
		handleTimeRangeChange() {
			// 切换时间范围时，只重新加载充电统计
			this.loadChargingStats()
		},
		handleChartRangeChange() {
			this.updateChart()
		},
		initChart() {
			const chartDom = document.getElementById('chargingChart')
			if (!chartDom) return
			this.chart = echarts.init(chartDom)
			this.updateChart()
		},
		updateChart() {
			if (!this.chart) return

			const days = parseInt(this.chartRange)
			// 调用接口获取每日数据
			getDailyData({ days: days }).then(res => res.data).then(res => {
				if (res.code == 200 && res.data) {
					const dailyData = res.data || []
					const dates = []
					const amounts = []
					const counts = []

					// 处理接口返回的数据
					dailyData.forEach(item => {
						// 格式化日期
						const dateStr = item.date || ''
						let displayDate = dateStr
						if (dateStr) {
							// 如果是 YYYY-MM-DD 格式，转换为 M/D
							if (dateStr.includes('-')) {
								const parts = dateStr.split('-')
								if (parts.length >= 2) {
									displayDate = `${parseInt(parts[1])}/${parseInt(parts[2])}`
								}
							}
						}
						dates.push(displayDate)
						
						// 金额（可能是分，需要转换）
						let amount = item.amount || 0
						// if (amount > 1000) {
							amount = amount / 100
						// }
						amounts.push(parseFloat(amount.toFixed(2)))
						
						// 次数
						counts.push(item.count || 0)
					})

					// 如果数据为空，使用空数据
					if (dates.length === 0) {
						this.initEmptyChartData(days)
						return
					}

					const option = {
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'cross'
							},
							formatter: function(params) {
								let result = params[0].name + '<br/>'
								params.forEach(function(item) {
									if (item.seriesName === '金额（元）') {
										result += item.marker + item.seriesName + ': ¥' + item.value + '<br/>'
									} else {
										result += item.marker + item.seriesName + ': ' + item.value + '<br/>'
									}
								})
								return result
							}
						},
						legend: {
							data: ['金额（元）', '次数'],
							top: 10
						},
						grid: {
							left: '10%',
							right: '8%',
							bottom: '8%',
							top: '15%',
							containLabel: false
						},
						xAxis: {
							type: 'category',
							boundaryGap: [0.1, 0.1],
							data: dates,
							axisLine: {
								show: true,
								lineStyle: {
									color: '#e0e0e0'
								}
							},
							axisTick: {
								show: true,
								alignWithLabel: true
							}
						},
						yAxis: [
							{
								type: 'value',
								name: '金额（元）',
								position: 'left',
								axisLabel: {
									formatter: '¥{value}',
									margin: 8
								},
								axisLine: {
									show: true,
									lineStyle: {
										color: '#409EFF'
									}
								},
								splitLine: {
									show: true,
									lineStyle: {
										color: '#f0f0f0',
										type: 'dashed'
									}
								}
							},
							{
								type: 'value',
								name: '次数',
								position: 'right',
								axisLabel: {
									margin: 8
								},
								axisLine: {
									show: true,
									lineStyle: {
										color: '#67C23A'
									}
								},
								splitLine: {
									show: false
								}
							}
						],
						series: [
							{
								name: '金额（元）',
								type: 'bar',
								data: amounts,
								barWidth: '35%',
								barCategoryGap: '20%',
								itemStyle: {
									color: '#409EFF',
									borderRadius: [4, 4, 0, 0]
								},
								emphasis: {
									itemStyle: {
										color: '#66b1ff'
									}
								}
							},
							{
								name: '次数',
								type: 'line',
								yAxisIndex: 1,
								data: counts,
								symbol: 'circle',
								symbolSize: 6,
								itemStyle: {
									color: '#67C23A'
								},
								lineStyle: {
									width: 3,
									type: 'solid'
								},
								areaStyle: {
									color: {
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [
											{ offset: 0, color: 'rgba(103, 194, 58, 0.3)' },
											{ offset: 1, color: 'rgba(103, 194, 58, 0.05)' }
										]
									}
								}
							}
						]
					}

					this.chart.setOption(option)
				} else {
					// 接口失败时使用空数据
					this.initEmptyChartData(days, [], [], [])
				}
			}).catch(error => {
				console.error('获取每日数据失败:', error)
				// 出错时使用空数据
				this.initEmptyChartData(days)
			})
		},
		// 初始化空图表数据（当接口失败时）
		initEmptyChartData(days) {
			const dates = []
			const amounts = []
			const counts = []
			
			// 生成日期数据
			for (let i = days - 1; i >= 0; i--) {
				const date = new Date()
				date.setDate(date.getDate() - i)
				const month = date.getMonth() + 1
				const day = date.getDate()
				dates.push(`${month}/${day}`)
				amounts.push(0)
				counts.push(0)
			}

			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					}
				},
				legend: {
					data: ['金额（元）', '次数'],
					top: 10
				},
				grid: {
					left: '10%',
					right: '8%',
					bottom: '8%',
					top: '15%',
					containLabel: false
				},
				xAxis: {
					type: 'category',
					boundaryGap: [0.1, 0.1],
					data: dates,
					axisLine: {
						show: true,
						lineStyle: {
							color: '#e0e0e0'
						}
					},
					axisTick: {
						show: true,
						alignWithLabel: true
					}
				},
				yAxis: [
					{
						type: 'value',
						name: '金额（元）',
						position: 'left',
						axisLabel: {
							formatter: '¥{value}',
							margin: 8
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#409EFF'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#f0f0f0',
								type: 'dashed'
							}
						}
					},
					{
						type: 'value',
						name: '次数',
						position: 'right',
						axisLabel: {
							margin: 8
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#67C23A'
							}
						},
						splitLine: {
							show: false
						}
					}
				],
				series: [
					{
						name: '金额（元）',
						type: 'bar',
						data: amounts,
						barWidth: '35%',
						barCategoryGap: '20%',
						itemStyle: {
							color: '#409EFF',
							borderRadius: [4, 4, 0, 0]
						},
						emphasis: {
							itemStyle: {
								color: '#66b1ff'
							}
						}
					},
					{
						name: '次数',
						type: 'line',
						yAxisIndex: 1,
						data: counts,
						symbol: 'circle',
						symbolSize: 6,
						itemStyle: {
							color: '#67C23A'
						},
						lineStyle: {
							width: 3,
							type: 'solid'
						},
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [
									{ offset: 0, color: 'rgba(103, 194, 58, 0.3)' },
									{ offset: 1, color: 'rgba(103, 194, 58, 0.05)' }
								]
							}
						}
					}
				]
			}

			if (this.chart) {
				this.chart.setOption(option)
			}
		},
		handleResize() {
			if (this.chart) {
				this.chart.resize()
			}
		}
	}
}
</script>

<style scoped>
.dashboard-container {
	padding: 20px;
	background: #f5f7fa;
	min-height: calc(100vh - 84px);
}

.stats-row {
	margin-bottom: 20px;
}

.stat-card {
	cursor: pointer;
	transition: all 0.3s;
}

.stat-card:hover {
	transform: translateY(-5px);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.stat-content {
	display: flex;
	align-items: center;
}

.stat-icon {
	width: 60px;
	height: 60px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 15px;
}

.stat-icon i {
	font-size: 28px;
	color: #fff;
}

.stat-info {
	flex: 1;
}

.stat-value {
	font-size: 28px;
	font-weight: bold;
	color: #303133;
	margin-bottom: 5px;
}

.stat-label {
	font-size: 14px;
	color: #909399;
}

.chart-container {
	width: 100%;
	height: 400px;
}

h3 {
	color: #303133;
	font-size: 18px;
	font-weight: 600;
}

/* 时间范围切换卡片样式 */
.time-range-card {
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	border: none;
	box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
}

.time-range-header {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	color: #fff;
	font-size: 16px;
	font-weight: 600;
}

.time-range-header i {
	font-size: 20px;
	margin-right: 8px;
}

.time-range-title {
	font-size: 16px;
}

.time-range-buttons {
	display: flex;
	gap: 15px;
	justify-content: space-around;
}

.time-range-btn {
	flex: 1;
	background: rgba(255, 255, 255, 0.15);
	border: 2px solid rgba(255, 255, 255, 0.3);
	border-radius: 12px;
	padding: 20px 15px;
	cursor: pointer;
	transition: all 0.3s ease;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	backdrop-filter: blur(10px);
}

.time-range-btn:hover {
	background: rgba(255, 255, 255, 0.25);
	border-color: rgba(255, 255, 255, 0.5);
	transform: translateY(-3px);
	box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.time-range-btn.active {
	background: rgba(255, 255, 255, 0.95);
	border-color: #fff;
	color: #667eea;
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
	transform: translateY(-5px);
}

.time-range-btn.active .btn-icon {
	color: #667eea;
}

.time-range-btn.active .btn-label {
	color: #667eea;
	font-weight: 600;
}

.time-range-btn.active .btn-desc {
	color: #999;
}

.btn-icon {
	font-size: 32px;
	margin-bottom: 10px;
	color: rgba(255, 255, 255, 0.9);
	transition: all 0.3s ease;
}

.btn-content {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.btn-label {
	font-size: 18px;
	font-weight: 600;
	color: #fff;
	margin-bottom: 5px;
	transition: all 0.3s ease;
}

.btn-desc {
	font-size: 12px;
	color: rgba(255, 255, 255, 0.7);
	transition: all 0.3s ease;
}
</style>
